import React from 'react';
import Slider from "react-slick"; // Import react-slick for carousel
import "../styles/Buy.css"
import buy from "../assets/images/buy.png"
import buy1 from "../assets/images/buy1.png"
import buy2 from "../assets/images/buy2.png"
import buy3 from "../assets/images/buy3.png"
import buy4 from "../assets/images/buy4.webp"
import buy5 from "../assets/images/buy5.webp"
const TrustedBrands = () => {
  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 2000,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    rtl: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };

  return (
    <article className="containerPartener">
      <h2>You can Find us at</h2>
      <section className="customer-logos trsutedBrandsImg" dir="rtl">
        <Slider {...settings} className="slick customer-logos">
          <div className="slide">
            <img src={buy} alt="Brand 1" />
          </div>
          <div className="slide">
            <img src={buy3} alt="Brand 2" />
          </div>
          <div className="slide">
            <img src={buy1} alt="Brand 3" />
          </div>
          <div className="slide">
            <img src={buy2} alt="Brand 4" />
          </div>
          <div className="slide">
            <img src={buy3} alt="Brand 5" />
          </div>
          <div className="slide">
            <img src={buy4} alt="Brand 5" />
          </div>
          <div className="slide">
            <img src={buy5} alt="Brand 5" />
          </div>

        </Slider>
      </section>
    </article>
  );
};

export default TrustedBrands;
